import React, { useContext, useEffect, useState } from "react";
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import arrowRight from "../assets/images/arrow-right.svg";
import uploadIcon from "../assets/images/UploadIcon.svg";
import VerifiedUser from "../assets/images/VerifiedUserBlue.svg";
import { useLocation, useNavigate } from "react-router-dom";
import closeIcon from "../assets/images/closeIcon.svg";
import aboutJobIcon from "../assets/images/aboutJobBlue.svg";
import logo2 from "../assets/images/logo (1).svg";
import aboutCompanyIcon from "../assets/images/aboutCompnyBlue.svg";
import backtoTopIcon from "../assets/images/backToTopBlue.svg";
import BackIcon from "../assets/images/ArrowBackBlue.svg";
import { useDispatch, useSelector } from "react-redux";
import ApiConfig, { BASE_URL } from "../api/ApiConfig";
import arrowUp from "../assets/images/arrow-square-up.svg";
import companyLogo from "../assets/images/building-07.svg";
import jobBriefcse from "../assets/images/jobBreifCase.svg";
import { educationLevel } from "../constant/educationLevel";
import gotop from "../assets/images/arrow-square-up.svg";
import {
  PostCallWithErrorResponse,
  simpleGetCall,
  simplePostCall,
  simplePostTokenCall,
} from "../api/ApiServices";
import { expOptions } from "../constant/exprience";
import { toast } from "react-toastify";
import { getBrowser } from "../constant/getBrowser";
import { getOS } from "../constant/getOS";
import { updateData } from "../redux/roundtoSlice";
import { AppContext } from "../contaxt/AppContext";
import { isValidEmail } from "../common";
import CustomSelect from "../components/customSlect";
import CustomButton from "../components/customButton";
import PhoneNumber from "../components/phoneNumber";
import { countryCodes } from "../constant/countryCodes";
import { Modal } from "react-bootstrap";
import "../assets/style/Applicationstatus.css";
import salaryOptions from "../constant/salaryRange";

const JobApplicationProcess = (props) => {
  const {
    indutries,
    specialization,
    details,
    setDetails,
    handleProceed,
    handleGoBack,
    customQuestion,
    errors,
    setErrors,
    isApiCalled,
    departments,
    isNotFilledData,
    isRedirect,
    handleUserCreateOnNo,
    handleValidedEmailMsg
  } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const state = useSelector((state) => state.roundData);

  const showBackButton = location.state?.fromOtherPage || false;

  const handleInputChange = (e) => {



    let { name, value } = e.target;

    if (name === 'name' && value?.length === 40) {
      return
    }

    if (name === 'email') value = value.trim()

    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {

      const allowedExtensions = ['pdf', 'doc', 'docx'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        toast.error('Please upload only PDF, DOC, or DOCX files.');
        e.target.value = '';
        return;
      }

      const fileSizeMB = file.size / (1024 * 1024); // size in MB
      if (fileSizeMB > 25) {
        toast.error("File size exceeds 25MB. Please upload a smaller file.");
        e.target.value = ""; // reset the file input
      } else {
        document.getElementById("UploadResumeInput").value = file.name;

        const reader = new FileReader();
        reader.readAsDataURL(file);
        let base64String;
        reader.onload = () => {
          base64String = reader.result;
          setDetails((prev) => ({
            ...prev,
            uploadResumeName: (document.getElementById(
              "UploadResumeInput"
            ).value = file.name),
            uploadResume: base64String,
          }));

          setErrors({ ...errors, resume: "" });
        };
      }
    }
  };

  const [activeSection, setActiveSection] = useState(null);

  const handleIconClick = (section) => {
    if (section === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      setActiveSection(section);
    }
  };

  const handleClose = () => {
    setActiveSection(null);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 640 && activeSection) {
        setActiveSection(null);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [activeSection]);
  const [showModal, setShowModal] = useState(false);

  const handleConfirm = () => {
    alert("Email updated!");
    setShowModal(false);
  };

  const handleClosemodal = () => {
    setShowModal(false);
  };
  return (
    <div className="JAPWrap">
      <div className="jaPlftRgt">
        <div className="japLftWidtH">
          <div className="JAPLft-side">
            <div className="jCFaBox">
              <div className="JAF-input-group-sm">
                <input
                  type="text"
                  id="codeIn"
                  name="codeInput"
                  placeholder="Enter job code"
                  value={state.code}
                  disabled
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={VerifiedUser}
                    className="sucsIcon"
                    alt="Success Icon"
                  />
                </div>
              </div>
            </div>
            <div className="JAPLft-inr-box">
              <div className="hgtJtBox">
                <p>{state?.position}</p>
                <div className="hgtJtContent">{state?.aboutJob}</div>
              </div>

              <div className="hgtAcBox">
                <div className="company-info">
                  <div className="companyLogoWrap">
                    <img
                      src={BASE_URL + state?.companyLogo}
                      alt="Logo"
                      onError={(e) => (e.target.src = LYWOLogoSmall)}
                      style={{ width: "100px" }}
                    />
                  </div>
                  <p>{state?.companyname}</p>
                </div>
                <div
                  className="hgtAcContent"
                  style={{
                    color: "#3a4b68",
                    justifyContent: "center",
                    lineHeight: "20px",
                  }}
                >
                  {state?.aboutCompany}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="japrgtWidtH">
          <div className="JAPformSpc">
            <div className="jCFaWhiteBox">
              <div className="pdgJAFBox">
                <div className="JAFhdGWrap">
                  <h3>Job Application Form</h3>
                  <p>Please fill your details to apply for this position</p>
                </div>
                <div className="logInCodeWrap lICwidtH">
                  <div className="">
                    <div className="mb-3">
                      <label htmlFor="Name">Name <span className="astrics">*</span></label>
                      <div className="input-group">
                        <input
                          // disabled={state.isEditDetails}
                          type="text"
                          id="Name"
                          name="name"
                          placeholder="Type here"
                          value={details.name}
                          onChange={handleInputChange}
                          className={`boxShowDow
                           ${errors.name && !details?.name?.trim()
                              ? "input-error-jaf"
                              : ""
                            }
                          `}
                        />
                        {errors.name && !details.name?.trim() && (
                          <span className="error-text-jaf">{errors.name}</span>
                        )}
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="Email">Email <span className="astrics">*</span></label>
                      <div className="input-group">
                        <input
                          type="text"
                          // disabled={state.isEditDetails}
                          id="Email"
                          name="email"
                          placeholder="Type here"
                          value={details.email}
                          onChange={handleInputChange}
                          onBlur={handleValidedEmailMsg}
                          className={`
                            boxShowDow
                           ${errors.email && !isValidEmail(details?.email)
                              ? "input-error-jaf"
                              : ""
                            }`}
                        />
                        {errors.email && !isValidEmail(details?.email) && (
                          <span className="error-text-jaf">{errors.email}</span>
                        )}{" "}
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="Phone">Phone <span className="astrics">*</span></label>
                      <div>
                        {/* <PhoneNumber /> */}
                        <div className=" d-flex gap-1">
                          <div
                            className="input-group"
                            style={{ marginTop: "-3px", width: "100px" }}
                          >
                            <CustomSelect
                              options={countryCodes}
                              labelKey={"dial_code"}
                              valKey={"dial_code"}
                              value={details.countryCode}
                              handleChange={(e) => {



                                handleInputChange({
                                  target: { name: "countryCode", value: e },
                                });
                              }}
                              hideIcon={true}
                              isClearaAble={false}
                            />
                          </div>
                          <div className="input-group">
                            <input
                              type="tel"
                              style={{ height: "52px" }}
                              id="Phone"
                              // disabled={state.isEditDetails}
                              name="no"
                              placeholder="Phone"
                              value={details.no}
                              // onChange={handleInputChange}
                              onBlur={handleUserCreateOnNo}
                              onChange={(e) => {

                                if (e.target.value.length > 10) return

                                // Allow only digits
                                const cleanedValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                handleInputChange({
                                  target: { name: "no", value: cleanedValue?.trim() },
                                });
                              }}
                              className={`
                            boxShowDow
                           ${errors.no &&
                                  (details.no?.trim().length < 9 ||
                                    details.no?.trim().length > 14)
                                  ? "input-error-jaf"
                                  : ""
                                }`}
                            />
                            {errors.no &&
                              (details.no?.trim().length < 9 ||
                                details.no?.trim().length > 14) && (
                                <span className="error-text-jaf">
                                  {errors.no}
                                </span>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="EducationLevelInput">
                        Education Level <span className="astrics">*</span>
                      </label>
                      <div className="input-group" name="educationLevel">
                        <CustomSelect
                          placeholder="Type here to search"
                          options={educationLevel}
                          labelKey={"label"}
                          valKey={"label"}
                          value={details.educationlevel}
                          errorMsg={
                            !details.educationlevel && errors.educationLevel
                          }
                          handleChange={(e) => {
                            handleInputChange({
                              target: { name: "educationlevel", value: e },
                            });
                          }}
                          isClearaAble={false}
                        />
                      </div>
                      {errors.educationLevel && !details.educationlevel && (
                        <span className="error-text-jaf">
                          {errors.educationLevel}
                        </span>
                      )}
                    </div>
                    <div className="mb-3" name='fieldOfEducation'>
                      <label htmlFor="FieldOfEducationInput">
                        Field of Education <span className="astrics">*</span>
                      </label>
                      <div className="input-group">
                        <CustomSelect
                          placeholder="Type here to search"
                          options={specialization}
                          labelKey={"specializationName"}
                          valKey={"specializationId"}
                          value={details.fieldOfEducation}
                          errorMsg={
                            !details.fieldOfEducation && errors.fieldOfEducation
                          }
                          handleChange={(e) => {
                            handleInputChange({
                              target: { name: "fieldOfEducation", value: e },
                            });
                          }}
                          isClearaAble={false}
                        />
                      </div>
                      {errors.fieldOfEducation && !details.fieldOfEducation && (
                        <span className="error-text-jaf">
                          {errors.fieldOfEducation}
                        </span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label htmlFor="ExperienceInput">
                        Experience (in years) <span className="astrics">*</span>
                      </label>
                      <div className="input-group">
                        <CustomSelect
                          placeholder="Type here to search"
                          options={expOptions}
                          labelKey={"label"}
                          valKey={"value"}
                          value={details.experinces}
                          errorMsg={
                            !details.experinces && errors.experinces
                          }
                          handleChange={(e) => {
                            handleInputChange({
                              target: { name: "experinces", value: e },
                            });
                          }}
                          isClearaAble={false}
                        />
                      </div>
                      {errors.experinces && !details.experinces?.trim() && (
                        <span className="error-text-jaf">
                          {errors.experinces}
                        </span>
                      )}
                    </div>
                    {
                      details?.experinces != "0" && <>
                        <div className="mb-3" name="currentDepartment">
                          <label htmlFor="CurrentJobTitleInput">
                            Current Job Title {details?.experinces != "0" && <span className="astrics">*</span>}
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              id="CurrentJobTitleInput"
                              name="currentJobTittle"
                              placeholder="Type here"
                              disabled={details?.experinces == "0"}
                              value={details.currentJobTittle}
                              onChange={handleInputChange}
                              className={`
                            boxShowDow
                           ${errors.currentJobTitle &&
                                  !details.currentJobTittle?.trim()
                                  ? "input-error-jaf"
                                  : ""
                                }`}
                            />
                            {errors.currentJobTitle &&
                              !details.currentJobTittle?.trim() && (
                                <span className="error-text-jaf">
                                  {errors.currentJobTitle}
                                </span>
                              )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <label htmlFor="CurrentCompanyInput">
                            Current Company {details?.experinces != "0" && <span className="astrics">*</span>}
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              id="CurrentCompanyInput"
                              name="currentCompany"
                              placeholder="Type here"
                              value={details.currentCompany}
                              disabled={details?.experinces == "0"}
                              onChange={handleInputChange}
                              className={`
                            boxShowDow
                           ${errors.currentCompany &&
                                  !details.currentCompany?.trim()
                                  ? "input-error-jaf"
                                  : ""
                                }`}
                            />
                            {errors.currentCompany &&
                              !details.currentCompany?.trim() && (
                                <span className="error-text-jaf">
                                  {errors.currentCompany}
                                </span>
                              )}
                          </div>
                        </div>

                        <div className="mb-3">
                          <label htmlFor="CurrentDepartmentInput">Department {details?.experinces != "0" && <span className="astrics">*</span>}</label>
                          <div className="input-group">
                            <CustomSelect
                              placeholder="Type here to Search"
                              options={departments}
                              labelKey={"name"}
                              isDisabled={details?.experinces == "0"}
                              valKey={"id"}
                              value={details.departmentId}
                              errorMsg={
                                !details.departmentId && errors.currentDepartment
                              }
                              handleChange={(e) => {
                                handleInputChange({
                                  target: { name: "departmentId", value: e },
                                });
                              }}
                              isClearaAble={false}
                            />
                          </div>
                          <p className="mt-1" style={{ fontSize: "11px" }}>
                            Select the closest match.
                          </p>
                          {errors.currentDepartment && !details.departmentId && (
                            <span className="error-text-jaf">
                              {errors.currentDepartment}
                            </span>
                          )}
                        </div>
                        <div className="mb-3" name='currentIndustry'>
                          <label htmlFor="CurrentIndustryInput">
                            Current Industry {details?.experinces != "0" && <span className="astrics">*</span>}
                          </label>
                          <div className="input-group">
                            <CustomSelect
                              placeholder="Type here to Search"
                              options={indutries}
                              labelKey={"label"}
                              isDisabled={details?.experinces == "0"}
                              valKey={"label"}
                              value={details.currentIndustry}
                              errorMsg={
                                !details.currentIndustry && errors.currentIndustry
                              }
                              handleChange={(e) => {
                                handleInputChange({
                                  target: { name: "currentIndustry", value: e },
                                });
                              }}
                              isClearaAble={false}
                            />
                          </div>
                          {errors.currentIndustry && !details.currentIndustry && (
                            <span className="error-text-jaf">
                              {errors.currentIndustry}
                            </span>
                          )}
                        </div>
                      </>
                    }
                    <div className="mb-3" name='expectedSalary'>
                      <label htmlFor="CurrentIndustryInput">
                        Expected Salary <span className="astrics">*</span>
                      </label>
                      <div className="input-group">
                        <CustomSelect
                          placeholder="Type here to Search"
                          options={salaryOptions}
                          labelKey={"label"}
                          valKey={"label"}
                          value={details.expectedSalary}
                          errorMsg={
                            !details.expectedSalary && errors.expectedSalary
                          }
                          handleChange={(e) => {
                            handleInputChange({
                              target: { name: "expectedSalary", value: e },
                            });
                          }}
                          isClearaAble={false}
                        />
                      </div>
                      {errors.expectedSalary && !details.expectedSalary && (
                        <span className="error-text-jaf">
                          {errors.expectedSalary}
                        </span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label htmlFor="currentLocation">Location <span className="astrics">*</span></label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="currentLocation"
                          name="currentLocation"
                          placeholder="Type here"
                          value={details.currentLocation}
                          onChange={handleInputChange}
                          className={`
                            boxShowDow
                           ${errors.currentLocation &&
                              !details.currentLocation?.trim()
                              ? "input-error-jaf"
                              : ""
                            }`}
                        />
                        {errors.currentLocation &&
                          !details.currentLocation?.trim() && (
                            <span className="error-text-jaf">
                              {errors.currentLocation}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="AvailableFromInput">Available From <span className="astrics">*</span></label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="AvailableFromInput"
                          name="availableFrom"
                          placeholder="Available From"
                          value={details.availableFrom?.slice(0, 10) || ""}
                          onChange={handleInputChange}
                          className={
                            errors.availableFrom && !details.availableFrom
                              ? "input-error-jaf"
                              : ""
                          }
                        />
                        {errors.availableFrom && !details.availableFrom && (
                          <span className="error-text-jaf">
                            {errors.availableFrom}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="YesOrNoInput">
                        Buy Out Option Available? <span className="astrics">*</span>
                      </label>
                      <div
                        className={
                          errors.buyOutOption &&
                            !details?.noticePeriodbuyoptions
                            ? "input-radio-error-jaf"
                            : "radio-input-wrap"
                        }
                      >
                        <div className="input-group yes-noinp">
                          <div className="form-check form-check-inline mb-0">
                            <input
                              type="radio"
                              id="buyOutOptionYes"
                              name="noticePeriodbuyoptions"
                              className="form-check-input"
                              value="Yes"
                              checked={details.noticePeriodbuyoptions === "Yes"}
                              onChange={handleInputChange}
                              style={{ cursor: "pointer" }}
                            />
                            <label
                              htmlFor="buyOutOptionYes"
                              className="form-check-label mb-0 mt-1"
                            >
                              Yes
                            </label>
                          </div>
                          <div className="form-check form-check-inline mb-0">
                            <input
                              type="radio"
                              id="buyOutOptionNo"
                              name="noticePeriodbuyoptions"
                              className="form-check-input"
                              value="No"
                              checked={details.noticePeriodbuyoptions === "No"}
                              onChange={handleInputChange}
                              style={{ cursor: "pointer" }}
                            />
                            <label
                              htmlFor="buyOutOptionNo"
                              className="form-check-label mb-0 mt-1"
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                      {errors.buyOutOption &&
                        !details?.noticePeriodbuyoptions && (
                          <span className="error-text-jaf">
                            {errors.buyOutOption}
                          </span>
                        )}
                    </div>
                    {customQuestion?.map((ques, index) => {
                      if (!ques?.isActive) return null;

                      let fieldName = `customQuestion${index + 1}`;

                      return (
                        <div className="mb-3">
                          <label htmlFor="YesOrNoInput">
                            {ques?.questionText} <span className="astrics">*</span>
                          </label>
                          <div
                            className={
                              errors[fieldName] && !details[fieldName]
                                ? "input-radio-error-jaf"
                                : "radio-input-wrap"
                            }
                          >
                            <div className="input-group yes-noinp">
                              <div className="form-check form-check-inline mb-0">
                                <input
                                  type="radio"
                                  id={fieldName}
                                  name={fieldName}
                                  className="form-check-input"
                                  value="Yes"
                                  checked={details[fieldName] === "Yes"}
                                  onChange={handleInputChange}
                                  style={{ cursor: "pointer" }}
                                />
                                <label
                                  htmlFor={fieldName}
                                  className="form-check-label mb-0 mt-1"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check form-check-inline mb-0">
                                <input
                                  type="radio"
                                  id={fieldName}
                                  name={fieldName}
                                  className="form-check-input"
                                  value="No"
                                  checked={details[fieldName] == "No"}
                                  onChange={handleInputChange}
                                  style={{ cursor: "pointer" }}
                                />
                                <label
                                  htmlFor={fieldName}
                                  className="form-check-label mb-0 mt-1"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                          {errors[fieldName] && !details[fieldName] && (
                            <span className="error-text-jaf">
                              {errors[fieldName]}
                            </span>
                          )}
                        </div>
                      );
                    })}

                    <div className="mb-3">
                      <label htmlFor="UploadResumeInput">Upload Resume <span className="astrics">*</span></label>
                      <div className="input-group">
                        <input
                          readOnly
                          type="text"
                          id="UploadResumeInput"
                          name="resume"
                          placeholder="Upload Resume"
                          style={{
                            cursor: "pointer",
                            paddingRight: "40px",
                            borderRadius: "8px",
                          }}
                          onClick={() =>
                            document.getElementById("hiddenFileInput").click()
                          }
                          value={details.uploadResumeName}
                          className={`
                            boxShowDow
                            ${errors.resume && !details.uploadResumeName
                              ? "input-error-jaf"
                              : ""
                            }`}
                        />
                        <img
                          src={uploadIcon}
                          className="uploadIconStyl"
                          alt="Upload Icon"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            document.getElementById("hiddenFileInput").click()
                          }
                        />
                        <input
                          type="file"
                          id="hiddenFileInput"
                          style={{ display: "none" }}
                          accept=".pdf, .doc, .docx"
                          onChange={handleFileChange}
                        />
                      </div>
                      {errors.resume && !details.uploadResumeName && (
                        <span className="error-text-jaf">{errors.resume}</span>
                      )}
                      <p className="mt-2" style={{ fontSize: "11px" }}>
                        Upload your resume as a PDF or Word file, no larger than
                        25MBs.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="btnAreaWrap">
                  <CustomButton
                    title={state?.isEditDetails && !isRedirect ? "Save & Go back" : "Proceed"}
                    handleClick={handleProceed}
                    isIcon={true}
                    src={arrowRight}
                    isLoading={isApiCalled}
                  />
                </div>
                {
                  isNotFilledData &&

                  <div className="d-flex justify-content-center mt-2">
                    <p className="text-danger">Please fill all mandatory (*) fields to Proceed</p>
                  </div>
                }
              </div>

            </div>
          </div>
        </div>
      </div>

      {activeSection && (
        <div className="modalOverlayBg" onClick={handleClose}></div>
      )}
      <div className={`slideModal ${activeSection ? "open" : ""}`}>
        <div className="modalContentWrap">
          {activeSection === "aboutJob" && (
            <>
              <div className="modalJT">
                <div className="ModalcloseBtn">
                  <h4 className="mb-0">{state?.position}</h4>
                  <img
                    src={closeIcon}
                    className="mobIcon"
                    alt=""
                    onClick={handleClose}
                  />
                </div>
                <div className="modalJT-contnt">
                  <p>{state?.aboutJob}</p>
                </div>
              </div>
            </>
          )}
          {activeSection === "aboutCompany" && (
            <>
              <div className="modalAC">
                <div className="ModalcloseBtn">
                  {/* <h4 className="mb-0">Company</h4> */}
                  {/* <img
                    src={companyLogo}
                    className="mobIcon"
                    alt=""
                    onClick={handleClose}
                  /> */}
                </div>
                <div className="company-info">
                  <div className="companyLogoWrap">
                    <img
                      src={BASE_URL + state?.companyLogo}
                      className="companyLogo"
                      alt="Logo"
                      onError={(e) => (e.target.src = LYWOLogoSmall)}
                    />
                  </div>
                  <p>{state?.companyname}</p>
                </div>
                <div className="modalAC-contnt">
                  <p>{state?.aboutCompany}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="mobile-icons">
        {showBackButton && (
          <div className="mobile-icon-txt" onClick={handleGoBack}>
            <img src={BackIcon} className="mobIcon" alt="Back" />
            <p>Back</p>
          </div>
        )}
        <div
          className="mobile-icon-txt"
          onClick={() => handleIconClick("aboutJob")}
        >
          <img src={jobBriefcse} className="mobIcon" alt="About Job" />
          <p>Job</p>
        </div>
        <div
          className="mobile-icon-txt"
          onClick={() => handleIconClick("aboutCompany")}
        >
          <img src={companyLogo} className="mobIcon" alt="About Company" />
          <p>Company</p>
        </div>
        <div className="mobile-icon-txt" onClick={() => handleIconClick("top")}>
          <img src={gotop} className="mobIcon" alt="Back to Top" />
          <p>Back to Top</p>
        </div>
      </div>
    </div>
  );
};

export default JobApplicationProcess;
